module.exports = __webpack_public_path__ + "product/quote-20a5b8853a71d295f062acd558c3885d.svg";